// UI-only state: theme, sidebar collapsed, modal IDs. Never API state.
// A0 owns this; later agents add modal IDs only.
import { create } from "zustand";
import type { SurfaceMode } from "@/lib/catalog-pending/responsive/surfaceMode";

export type Theme = "light" | "dark";
export type ThemePreference = Theme | "system";

export type UiState = {
  theme: Theme;
  themePreference: ThemePreference;
  sidebarCollapsed: boolean;
  surfaceMode: SurfaceMode;
  setResolvedTheme: (theme: Theme) => void;
  setSurfaceMode: (mode: SurfaceMode) => void;
  setThemePreference: (preference: ThemePreference, resolved: Theme) => void;
  toggleSidebar: () => void;
};

export const useUiStore = create<UiState>((set) => ({
  theme: "dark",
  themePreference: "system",
  sidebarCollapsed: true,
  surfaceMode: "auto",
  setResolvedTheme: (theme) => set({ theme }),
  setSurfaceMode: (surfaceMode) => set({ surfaceMode }),
  setThemePreference: (themePreference, theme) =>
    set({ theme, themePreference }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
}));
